/**
 * The DOM attributes `AnimateNumber` writes and `client.tsx`'s hydration counter snapshot reads back.
 *
 * Its own module so the client ENTRY bundle, which builds the snapshot, does not pull the component in
 * — and shared as constants rather than by convention, because a rename on one side would silently
 * blank the snapshot instead of failing.
 */

/** The figure the render that produced this node was given. */
export const COUNTER_VALUE_ATTR = 'data-value'

/**
 * The locale that render formatted with.
 *
 * React does not patch attributes on hydration, so after a mismatch the DOM keeps the SERVER's value on
 * a hydrated node and the CLIENT's on one React regenerated — which is exactly what lets the snapshot
 * name the side that formatted with the wrong locale.
 */
export const COUNTER_LOCALE_ATTR = 'data-counter-locale'
